"use client";

import BaseModal from "../common/BaseModal";
import TextInput from "../input/TextInput";
import {useContext, useEffect, useState} from "react";
import {useAuth} from "../../providers/authProvider";
import {ApiContext} from "../contexts/ApiContext";
import {ValidationContext} from "../contexts/ValidationContext";
import DefaultButton from "../buttons/DefaultButton";
import SelectInput from "../input/SelectInput";
import CheckBoxInput from "../input/CheckBoxInput";
import NumberInput from "../input/NumberInput";

function NewCompanyVisitModal(
    props: {
        openModal: any;
        setOpenModal: any
    }
) {
    const {Url} = useContext(ApiContext)
    const [VisitDate, setVisitDate] = useState('')
    const [StartTime, setStartTime] = useState('')
    const [EndTime, setEndTime] = useState('')
    const [SoftSignUpDeadline, setSoftSignUpDeadline] = useState('')
    const [HardSignUpDeadline, setHardSignUpDeadline] = useState('')
    const [Locked, setLocked] = useState(false)
    const [Companies, setCompanies] = useState<any[]>([])
    const [CompanyID, setCompanyID] = useState<number | string>(0)
    const [MinChildAge, setMinChildAge] = useState<number | string>('')
    const [MaxChildAge, setMaxChildAge] = useState<number | string>('')
    const [MaxParticipants, setMaxParticipants] = useState<number | string>(500)
    const [PresentCategories, setPresentCategories] = useState<any[]>([])
    const [PresentCategoryID, setPresentCategoryID] = useState<number | string>(0)
    const [SignUpCode, setSignUpCode] = useState('')
    const [Address, setAddress] = useState('')
    const [City, setCity] = useState('')
    const [Zipcode, setZipcode] = useState('')
    const [message, setMessage] = useState('')
    const {token} = useAuth();
    const {nameRegex, nameErrorMessage} = useContext(ValidationContext)

    function addCompanyVisit(event: React.FormEvent) {
        event.preventDefault()

        fetch(Url + 'admin/company-visits', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },

            body: JSON.stringify({
                Date: VisitDate,
                StartTime: StartTime,
                EndTime: EndTime,
                SoftSignUpDeadline: SoftSignUpDeadline,
                HardSignUpDeadline: HardSignUpDeadline,
                Locked: Locked,
                Address: Address,
                City: City,
                Zipcode: Zipcode,
                CompanyID: Number(CompanyID),
                PresentCategoryID: Number(PresentCategoryID),
                SignUpCode: SignUpCode,
                MinChildAge: Number(MinChildAge),
                MaxChildAge: Number(MaxChildAge),
                MaxParticipants: Number(MaxParticipants),
            }),
        })
            .then((res) => {
                if (res.status === 200) {
                    setVisitDate('')
                    setStartTime('')
                    setEndTime('')
                    setSoftSignUpDeadline('')
                    setHardSignUpDeadline('')
                    setLocked(false)
                    setAddress('')
                    setCity('')
                    setZipcode('')
                    setCompanyID('')
                    setPresentCategoryID('')
                    setSignUpCode('')
                    setMinChildAge('')
                    setMaxChildAge(18)
                }
                return res.json()
            })
            .then((data) => {
                setMessage(data.message)
            })
    }
    useEffect(() => {
        if (token) {
            fetch(Url + 'admin/companies', {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
            })
                .then((res) => res.json())
                .then((data) => setCompanies(data))
        }
    }, [token, Url])

    useEffect(() => {
        if (token) {
            fetch(Url + 'admin/present-categories', {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
            })
                .then((res) => res.json())
                .then((data) => setPresentCategories(data))
        }
    }, [token, Url])

    function handleClose() {
        setMessage('')
        props.setOpenModal(false)
    }

    return (
        <BaseModal
            show={props.openModal}
            onClose={handleClose}
            title="Nieuw bedrijfsbezoek toevoegen"
            footer={
                <>
                    <DefaultButton onClick={addCompanyVisit} content="Toevoegen"/>
                    <DefaultButton onClick={handleClose} content="Sluiten"/>
                </>
            }
        >
            <p className="text-base leading-relaxed text-gray-500">
                Geeft de gegevens van het bedrijfsbezoek op en klik op toevoegen.
            </p>
            <p className="text-base leading-relaxed text-red-500">
                {message}
            </p>
            <SelectInput labelName="Bedrijf"
                         inputName="companyID"
                         onChange={(e: any) => setCompanyID(e.target.value as any)}
                         value={CompanyID as any}
                         errorMessage="Selecteer een van de opties uit de lijst"
                         options={Companies}
            />
            <TextInput
                labelName="Bezoekdatum"
                inputName="visitDate"
                value={VisitDate}
                placeholder="05/12/2024"
                errorMessage="Vul hier geldig datum in"
                pattern={undefined}
                type="date"
                onChange={(e) => setVisitDate(e.target.value)}
            />
            <TextInput
                labelName="Starttijd"
                inputName="startTime"
                onChange={(e) => setStartTime(e.target.value)}
                value={StartTime}
                placeholder="13:00"
                errorMessage="Vul hier een geldig tijdstip in"
                pattern={undefined}
                type="time"
            />
            <TextInput
                labelName="Eindtijd"
                inputName="endStime"
                onChange={(e) => setEndTime(e.target.value)}
                value={EndTime}
                placeholder="15:00"
                errorMessage="Vul hier een geldig tijdstip in"
                pattern={undefined}
                type="time"
            />
            <TextInput
                labelName="Adres"
                inputName="adres"
                onChange={(e) => setAddress(e.target.value)}
                value={Address}
                placeholder="Straat + Huisnummer"
                errorMessage={nameErrorMessage}
                pattern={nameRegex}
                type="text"
            />
            <TextInput
                labelName="Postcode"
                inputName="postcode"
                onChange={(e) => setZipcode(e.target.value)}
                value={Zipcode}
                placeholder="1234AA"
                errorMessage="Vul hier de postcode zonder spatie in"
                pattern="[0-9a-zA-Z ]{6,6}"
                type="text"
            />
            <TextInput
                labelName="Plaats"
                inputName="city"
                onChange={(e) => setCity(e.target.value)}
                value={City}
                placeholder="Plaats"
                errorMessage={nameErrorMessage}
                pattern={nameRegex}
                type="text"
            />
            <NumberInput
                labelName={"Min leeftijd kind"}
                inputName={"minChildAge"}
                value={MinChildAge}
                placeholder={"0"}
                min={0}
                max={99}
                step="1"
                errorMessage={"Geen geldige leeftijd"}
                onChange={(e) => setMinChildAge(e.target.value)}
            />
            <NumberInput
                labelName={"Max leeftijd kind"}
                inputName={"maxChildAge"}
                value={MaxChildAge}
                placeholder={"18"}
                min={0}
                max={99}
                step="1"
                errorMessage={"Geen geldige leeftijd"}
                onChange={(e) => setMaxChildAge(e.target.value)}
            />
            <NumberInput
                labelName={"Maximale zaalcapaciteit kinderen + volwassenen"}
                inputName={"maxParticipants"}
                value={MaxParticipants}
                placeholder={"500"}
                min={1}
                max={100000}
                step="1"
                errorMessage={"Geen geldig nummer"}
                onChange={(e) => setMaxParticipants(e.target.value)}
             />
            <p>De inschrijfdeadline is de deadline waarna het niet meer mogelijk om nieuwe kinderen in te schrijven. Ook is het nach deze deadline niet meer mogelijk om de cadeauselectie te wijzigen. De andere informatie in het grote boek, zoals hobbies kan na de deadline nog wel gewijzigd worden. </p>
            <TextInput
                labelName="Inschrijf deadline (zichtbaar voor klanten)"
                inputName="softSignUpDeadline"
                value={SoftSignUpDeadline}
                placeholder="05/12/2024"
                errorMessage="Vul hier geldig datum in"
                pattern={undefined}
                type="date"
                onChange={(e) => setSoftSignUpDeadline(e.target.value)}
            />
            <TextInput
                labelName="Inschrijf deadline (afgedwongen in systeem)"
                inputName="hardSignUpDeadline"
                value={HardSignUpDeadline}
                placeholder="05/12/2024"
                errorMessage="Vul hier geldig datum in"
                pattern={undefined}
                type="date"
                onChange={(e) => setHardSignUpDeadline(e.target.value)}
            />
            <p>Selecteer alleen een optie als de cadeauservice actief is. Niks selecteert dan is de cadeauservice inactief.</p>
            <SelectInput labelName="Cadeauservice"
                         inputName="presentCatID"
                         onChange={(e) => setPresentCategoryID(e.target.value)}
                         value={PresentCategoryID}
                         errorMessage="Selecteer een van de opties uit de lijst"
                         options={PresentCategories}
            />
            <TextInput
                labelName="Aanmeldcode"
                inputName="signUpCode"
                onChange={(e) => setSignUpCode(e.target.value)}
                value={SignUpCode}
                placeholder="jd79393"
                errorMessage="Vul hier de aanmeldcode in. De aanmeldcode moet minimaal acht tekens bevatten. Gebruik geen speciale tekens."
                pattern="[0-9a-zA-Z ]{8,}"
                type="text"
            />
            <p>
                Op het moment dat een bedrijf de status "Locked" heeft kan er niks meer gewijzigd worden.
            </p>
            <CheckBoxInput labelName="Locked" inputName="locked" value="yes" checked={Locked} setChecked={setLocked}/>
        </BaseModal>
    );
}

export default NewCompanyVisitModal
